/****************************************************
 * Module Name:  addCustomersettingsModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import IconButton from '@mui/material/IconButton';
import { LoadingButton } from "@mui/lab";
import { Box, Button, Checkbox, FormControlLabel, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";

import KeyboardDoubleArrowRightOutlined from "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import KeyboardDoubleArrowLeftOutlined from "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import KeyboardArrowLeftOutlined from "@mui/icons-material/KeyboardArrowLeftOutlined";
import KeyboardArrowRightOutlined from "@mui/icons-material/KeyboardArrowRightOutlined";

import Utility from "../../utility/utility";
import logo from '../../images/pansuriya.jpg';
import Constants from "../../utility/constants";
import CommonSnackbar from "../common/commonSnackBar";
import CustomerSellOutsourceProxy from "../../utility/proxy/manager/customersellOutsourceProxy";
import SaveIcon from '@mui/icons-material/Save';
import Select from "react-select";
import StoneTypeProxy from "../../utility/proxy/manager/stoneTypeProxy";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import CustomerFTPRenameColumnWrapper from "./customerFTPRenameColumnWrapper";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default class AddCustomersettingsModal extends Component {
  constructor(props) {
    super(props);

    let loginId = Constants.loggedInUser.id;
    let defaultEveryMinutes = 1;
    let currDt = new Date();
    let date = new Date();
    date.setMinutes(date.getMinutes() + parseInt(defaultEveryMinutes));

    this.state = {
      newCustomerId: this.props.editOperation ? this.props.sourceData.customerid : "",
      newHostname: this.props.editOperation ? this.props.sourceData.hostname : "",
      newPort: this.props.editOperation ? this.props.sourceData.port : "",
      newUsername: this.props.editOperation ? this.props.sourceData.username : "",
      newPassword: this.props.editOperation ? this.props.sourceData.password : "",
      newFingerprint: this.props.editOperation ? this.props.sourceData.fingerprint : "",
      newPublishinminute: this.props.editOperation ?
        this.props.sourceData.publishinminute :
        30,
      newLastpublished: this.props.editOperation ? this.props.sourceData.lastpublished : currDt,
      newCreatedby:
        this.props.editOperation ?
          this.props.sourceData.createdby :
          loginId,
      newCreatedat: this.props.editOperation ? this.props.sourceData.createdat : date,
      newFilename: this.props.editOperation ? this.props.sourceData.filename : "",
      newExcelcolumns: this.props.editOperation ? this.props.sourceData.excelcolumns : "",
      newStatus: this.props.editOperation ? this.props.sourceData.filterstatus : "",
      newStoneType: this.props.editOperation ? this.props.sourceData.filterstonetype : "",
      newDisabled: this.props.editOperation ? this.props.sourceData.disabled : true,
      newLocation: this.props.editOperation ? this.props.sourceData.filterlocation : "",

      renameColumnObj: {
        status: this.props.sourceData.status, shape: this.props.sourceData.shape, color: this.props.sourceData.color,
        clarity: this.props.sourceData.clarity, cut: this.props.sourceData.cut, pol: this.props.sourceData.pol,
        sym: this.props.sourceData.sym, flo: this.props.sourceData.flo, lab: this.props.sourceData.lab,
        location: this.props.sourceData.location, stonetype: this.props.sourceData.stonetype,
        milky: this.props.sourceData.milky, tinge: this.props.sourceData.tinge
      },
      showError: false,

      hostNameValidationError: "",
      portValidationError: "",
      userNameValidationError: "",
      passwordValidationError: "",
      publishinminuteValidationError: "",
      lastpublishedValidationError: "",
      filenameValidationError: "",

      srcAll: [],
      srcSelected: [],
      srcSearch: "",
      dstSearch: "",
      dstAll: this.props.editOperation ? this.getDstColumnsArray(this.props.sourceData.excelcolumns, 0) : [],
      dstRenamed: this.props.editOperation ? this.getDstColumnsArray(this.props.sourceData.excelcolumns, 1) : [],
      dstSelected: [],
      allStatusOptions: [],
      allStoneTypeOptions: [],
      allLocationOptions: [],
    }

  }

  componentDidMount() {
    this.fetchAllCustomerSellOutsourceColumnNames();
    this.setAllStatus();
    this.getAllStoneTypeData();
    this.getAllLocationData();
  }

  getAllStoneTypeData = () => {
    StoneTypeProxy.GetAllStoneType((response) => {
      if (response && Array.isArray(response)) {
        const allValues = response.map((stone) => stone.name);

        const optionsArray = [
          { value: allValues, label: "-- ANY --" },
          ...response.map((stone) => ({
            value: stone.name,
            label: stone.name,
          })),
        ];

        const stoneTypeArray = this.state.newStoneType.split(',').map(item => item.trim());

        const selectedOptions = optionsArray.filter((option) => {
          return stoneTypeArray.includes(option.value);
        });

        this.setState({
          allStoneTypeOptions: optionsArray,
          newStoneType: selectedOptions.length > 0 ? selectedOptions : [optionsArray[0]],
        });
      }
    });
  };

  getAllLocationData = () => {
    LocationProxy.GetAllLocation((response) => {
      if (response && Array.isArray(response)) {
        const allValues = response.map((stone) => stone.name);

        const optionsArray = [
          { value: allValues, label: "-- ANY --" },
          ...response.map((stone) => ({
            value: stone.name,
            label: stone.name,
          })),
        ];
        const locationArray = this.state.newLocation.split(',').map(item => item.trim());

        const selectedOptions = optionsArray.filter((option) => {
          return locationArray.includes(option.value);
        });

        this.setState({
          allLocationOptions: optionsArray,
          newLocation: selectedOptions.length > 0 ? selectedOptions : [optionsArray[0]],
        });
      }
    });
  };


  setAllStatus = () => {
    const optionsArray = Constants.STONE_STATUS.map((status) => ({
      value: status.value,
      label: status.label,
    }));
    const statusArray = this.state.newStatus.split(',').map(item => item.trim());
    const selectedOptions = optionsArray.filter((option) => {
      return statusArray.includes(option.value);
    });

    this.setState({
      allStatusOptions: optionsArray,
      newStatus: selectedOptions.length > 0 ? selectedOptions : [optionsArray[0]],
    });
  };

  getDstColumnsArray = (strExcelColumns, idx) => {
    let splittedCols = strExcelColumns.split(',');
    let retCols = [];

    splittedCols.map((iCol) => {
      let col = "";
      if (iCol.includes(":"))
        col = iCol.split(":")[idx].trim();
      else
        col = iCol.trim();

      retCols.push(col);
      return true;
    });

    return retCols;
  }

  //this function will only be called for status, stonetype and location since we have to filter the data in worker
  // we will only take union of data set of the values selected in the dropdown and the rename data set
  filerData = (newValue, renameData) => {
    const isAnySelected = newValue.some((val) => val.label === "-- ANY --");

    // If `-- ANY --` is selected, return all data as-is
    if (isAnySelected) {
      return renameData;
    }

    const renamedStatusData = renameData.split(',').reduce((acc, item) => {
      const [originalName, renamed] = item.split(':');
      acc[originalName.trim()] = renamed.trim();
      return acc;
    }, {});

    const valueString = newValue
      .map((status) => {
        const originalName = status.value;
        const renamed = renamedStatusData[originalName];
        return `${originalName}:${renamed}`;
      })
      .join(",");

    return valueString;
  }

  renameColumnData = (data) => {
    this.setState({ renameColumnObj: data });
  };

  handleSave = () => {
    let tExcelColumns = "";
    let date = new Date();

    this.state.dstAll.map((iDst, index) => {
      tExcelColumns += iDst + ":" + (!this.state.dstRenamed[index] || this.state.dstRenamed[index].trim() === "" ? iDst : this.state.dstRenamed[index].trim()) + ",";
      return true;
    });

    if (tExcelColumns.length > 0)
      tExcelColumns = tExcelColumns.substring(0, tExcelColumns.length - 1);

    // Helper function to check if a column is in dstAll before assigning it
    const addIfPresent = (key, value) => {
      return this.state.dstAll.includes(key) ? value : "";
    };

    const getCommaSeparatedValues = (optionsArray) => {
      if (!Array.isArray(optionsArray)) return '';
      const anyOption = optionsArray.find(option => option.label === '-- ANY --');
      if (anyOption) {
        return Array.isArray(anyOption.value)
          ? anyOption.value.join(',')
          : anyOption.value;
      }
      return optionsArray.map(option => option.value).join(',');
    };

    let data = {
      customerid: this.props.sourceData.customerid === this.props.customerId ?
        this.props.sourceData.customerid :
        this.props.customerId,
      hostname: this.state.newHostname,
      port: this.state.newPort,
      username: this.state.newUsername,
      password: this.state.newPassword,
      fingerprint: this.state.newFingerprint,
      publishinminute: this.state.newPublishinminute,
      lastpublished: this.props.editOperation ?
        Utility.ConvertLocalTimeToUtc(this.state.newLastpublished) :
        this.state.newLastpublished,
      createdby: Constants.loggedInUser.id,
      filename: this.state.newFilename,
      excelcolumns: tExcelColumns,
      createdat: Utility.ConvertLocalTimeToUtc(date),
      status: this.state.renameColumnObj.status,
      stonetype: this.state.renameColumnObj.stonetype,
      location: this.state.renameColumnObj.location,
      filterstatus: getCommaSeparatedValues(this.state.newStatus),
      filterlocation: getCommaSeparatedValues(this.state.newLocation),
      filterstonetype: getCommaSeparatedValues(this.state.newStoneType),
      lab: addIfPresent("lab", this.state.renameColumnObj.lab),
      shape: addIfPresent("shape", this.state.renameColumnObj.shape),
      clarity: addIfPresent("clarity", this.state.renameColumnObj.clarity),
      color: addIfPresent("color", this.state.renameColumnObj.color),
      cut: addIfPresent("cut", this.state.renameColumnObj.cut),
      pol: addIfPresent("pol", this.state.renameColumnObj.pol),
      sym: addIfPresent("sym", this.state.renameColumnObj.sym),
      flo: addIfPresent("flo", this.state.renameColumnObj.flo),
      milky: addIfPresent("milky", this.state.renameColumnObj.milky),
      tinge: addIfPresent("tinge", this.state.renameColumnObj.tinge),
      disabled: this.state.newDisabled,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) {
          this.props.handleSave(data);
        }
        else {
          this.setState({
            showError: true,
          });
        }
      } else this.props.handleSave(data);
    }
  };

  handleSelectChange = (key, selectedOption) => {
    let value = "";
    const existingData = this.state.renameColumnObj[key] || "";
    const existingMap = new Map(
      existingData.split(",").map(item => {
        const [key, value] = item.split(":").map(part => part.trim());
        return [key, value || key];
      })
    );

    if (selectedOption.some(option => option.label === "-- ANY --")) {
      let optionsArray = [];
      if (key === "status") {
        optionsArray = this.state.allStatusOptions;
      } else if (key === "location") {
        optionsArray = this.state.allLocationOptions;
      } else if (key === "stonetype") {
        optionsArray = this.state.allStoneTypeOptions;
      }
      optionsArray.forEach(option => {
        if (option.label !== "-- ANY --") {
          existingMap.set(option.value, existingMap.get(option.value) || option.value);
        }
      });
      value = Array.from(existingMap.entries()).map(([key, val]) => `${key}:${val}`).join(", ");
    } else {
      selectedOption.forEach(option => {
        existingMap.set(option.value, existingMap.get(option.value) || option.value);
      });
      value = Array.from(existingMap.entries()).map(([key, val]) => `${key}:${val}`).join(", ");
    }
    this.setState({ renameColumnObj: { ...this.state.renameColumnObj, [key]: value } });
  };

  buttonDisable = () => {
    if (
      !this.state.newHostname ||
      !this.state.newPort ||
      !this.state.newUsername ||
      !this.state.newPassword ||
      !this.state.newPublishinminute ||
      !this.state.newLastpublished ||
      !this.state.newCreatedby ||
      !this.state.newFilename ||
      !this.state.newExcelcolumns ||
      this.state.newDisabled == null ||
      this.state.newStatus.length === 0 ||
      this.state.newStoneType.length === 0 ||
      this.state.newLocation.length === 0
    )
      return true;

    return false;
  }

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  fetchAllCustomerSellOutsourceColumnNames = () => {
    CustomerSellOutsourceProxy.getAllCustomerSellOutsourceOutputColumnNames((res) => {
      if (res) {
        let newCols = [];
        res = res.sort((a, b) => a.localeCompare(b));
        res.map((iCol) => {
          if (!this.state.dstAll.includes(iCol))
            newCols.push(iCol);
          return true;
        })
        this.setState({ srcAll: newCols, srcSelected: [] });
      }
    })
  }

  setSrcSelected = (selectedItem) => {
    let tempSelectedSrc = undefined;
    if (this.state.srcSelected.includes(selectedItem)) {
      tempSelectedSrc = []
      this.state.srcSelected.map((iItem) => {
        if (iItem !== selectedItem)
          tempSelectedSrc.push(iItem);
        return true;
      });
    } else {
      tempSelectedSrc = [...this.state.srcSelected];
      tempSelectedSrc.push(selectedItem);
    }

    this.setState({
      srcSelected: tempSelectedSrc
    })
  }

  setDstSelected = (selectedItem) => {
    let tempSelectedDst = undefined;
    if (this.state.dstSelected.includes(selectedItem)) {
      tempSelectedDst = []
      this.state.dstSelected.map((iItem) => {
        if (iItem !== selectedItem)
          tempSelectedDst.push(iItem);
        return true;
      });
    } else {
      tempSelectedDst = [...this.state.dstSelected];
      tempSelectedDst.push(selectedItem);
    }

    this.setState({
      dstSelected: tempSelectedDst
    })
  }

  handleMoveAllToDst = () => {
    const filteredSrc = this.state.srcSearch
      ? this.state.srcAll.filter((item) =>
        item.toLowerCase().includes(this.state.srcSearch.toLowerCase())
      )
      : this.state.srcAll; // All items if no search  

    let tmpDst = [...this.state.dstAll, ...filteredSrc];
    let tmpDstRenamed = [...this.state.dstRenamed, ...filteredSrc];

    this.setState({
      dstAll: tmpDst,
      dstRenamed: tmpDstRenamed,
      srcAll: this.state.srcAll.filter((item) => !filteredSrc.includes(item)),
      srcSelected: [],
      newExcelcolumns: tmpDst
    });
  }

  handleMoveAllToSrc = () => {
    const filteredDst = this.state.dstSearch
      ? this.state.dstAll.filter((item) =>
        item.toLowerCase().includes(this.state.dstSearch.toLowerCase())
      )
      : this.state.dstAll; // All items if no search

    let tmpSrc = [...this.state.srcAll, ...filteredDst];

    this.setState({
      dstAll: this.state.dstAll.filter((item) => !filteredDst.includes(item)),
      dstRenamed: this.state.dstRenamed.filter(
        (_, index) => !filteredDst.includes(this.state.dstAll[index])
      ),
      srcAll: tmpSrc,
      dstSelected: [],
      newExcelcolumns: ""
    });
  }

  handleSelectedToDst = () => {
    let tmpDst = [...this.state.dstAll, ...this.state.srcSelected];
    let tmpDstRenamed = [...this.state.dstRenamed, ...this.state.srcSelected];
    let tmpSrc = [];
    this.state.srcAll.map((iSrc) => {
      if (!this.state.srcSelected.includes(iSrc))
        tmpSrc.push(iSrc);
      return true;
    })
    this.setState({
      dstAll: tmpDst,
      dstRenamed: tmpDstRenamed,
      srcAll: tmpSrc,
      srcSelected: [],
      newExcelcolumns: tmpDst
    });
  }

  handleSelectedToSrc = () => {
    let tmpSrc = [...this.state.srcAll, ...this.state.dstSelected];
    let tmpDst = [];
    let tmpDstRenamed = [];
    this.state.dstAll.map((iDst, index) => {
      if (!this.state.dstSelected.includes(iDst)) {
        tmpDst.push(iDst);
        tmpDstRenamed.push(this.state.dstRenamed[index]);
      }
      return true;
    })
    this.setState({
      srcAll: tmpSrc,
      dstAll: tmpDst,
      dstRenamed: tmpDstRenamed,
      dstSelected: [],
      newExcelcolumns: tmpDst.length === 0 ? "" : tmpDst
    });
  }

  shiftColumnUp = (index) => {
    if (index > 0) {
      this.setState((prevState) => {
        let updatedDstAll = [...prevState.dstAll]; // Copy the array
        [updatedDstAll[index], updatedDstAll[index - 1]] = [updatedDstAll[index - 1], updatedDstAll[index]]; // Swap elements

        let updatedDstRenamedAll = [...prevState.dstRenamed]; // Copy the array
        [updatedDstRenamedAll[index], updatedDstRenamedAll[index - 1]] = [updatedDstRenamedAll[index - 1], updatedDstRenamedAll[index]]; // Swap elements

        return { dstAll: updatedDstAll, dstRenamed: updatedDstRenamedAll };
      });
    }
  }

  shiftColumnDown = (index) => {
    if (index < this.state.dstAll.length - 1) {
      this.setState((prevState) => {
        let updatedDstAll = [...prevState.dstAll]; // Copy the array
        [updatedDstAll[index], updatedDstAll[index + 1]] = [updatedDstAll[index + 1], updatedDstAll[index]]; // Swap elements

        let updatedDstRenamedAll = [...prevState.dstRenamed]; // Copy the array
        [updatedDstRenamedAll[index], updatedDstRenamedAll[index + 1]] = [updatedDstRenamedAll[index + 1], updatedDstRenamedAll[index]]; // Swap elements

        return { dstAll: updatedDstAll, dstRenamed: updatedDstRenamedAll };
      });
    }
  }

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add Customer settings validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />
        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false} dialogClassName="ftp-modalSize">
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;Add or Edit Customer FTP Settings
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      <Form.Label >Customer Id</Form.Label>
                    </td>
                    <td>
                      <Form.Label style={{ fontWeight: 'bold' }}>
                        {this.props.sourceData.customerid === this.props.customerId ? this.props.sourceData.customerid : this.props.customerId}
                      </Form.Label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label >Created By</Form.Label>
                    </td>
                    <td>
                      <Form.Label style={{ fontWeight: 'bold' }}>
                        {this.props.sourceData.createdby ? this.props.sourceData.createdby : Constants.loggedInUser.id}
                      </Form.Label>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <Form.Label>
                        Host Name <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Host Name (required)"
                        placeholder=" Enter Host Name"
                        value={this.state.newHostname}
                        onChange={(e) =>
                          this.setState({
                            newHostname: e.target.value,
                            hostNameValidationError: e.target.value
                              ? ""
                              : "Host Name can't be Empty",
                          })
                        }
                        helperText={this.state.hostNameValidationError}
                        error={this.state.hostNameValidationError.length > 0}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <Form.Label>
                        Port <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        type="number"
                        label="Port (required)"
                        placeholder=" Enter Port"
                        value={this.state.newPort}
                        onChange={(e) =>
                          this.setState({
                            newPort: e.target.value,
                            portValidationError: e.target.value
                              ? ""
                              : "Port can't be Empty",
                          })
                        }
                        helperText={this.state.portValidationError}
                        error={this.state.portValidationError.length > 0}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <Form.Label>
                        User Name <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="User Name (required)"
                        placeholder=" Enter User Name"
                        value={this.state.newUsername}
                        onChange={(e) =>
                          this.setState({
                            newUsername: e.target.value,
                            userNameValidationError: e.target.value
                              ? ""
                              : "User Name can't be Empty",
                          })
                        }
                        helperText={this.state.userNameValidationError}
                        error={this.state.userNameValidationError.length > 0}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <Form.Label>
                        Password <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        type="password"
                        label="Password (required)"
                        placeholder=" Enter Password"
                        value={this.state.newPassword}
                        onChange={(e) =>
                          this.setState({
                            newPassword: e.target.value,
                            passwordValidationError: e.target.value
                              ? ""
                              : "Password can't be Empty",
                          })
                        }
                        helperText={this.state.passwordValidationError}
                        error={this.state.passwordValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Fingerprint
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        type="fingerprint"
                        label="fingerprint"
                        placeholder="Enter Fingerprint"
                        value={this.state.newFingerprint}
                        onChange={(e) =>
                          this.setState({
                            newFingerprint: e.target.value,
                          })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Publish In Minute <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Publish In Minute (required)"
                        placeholder=" Enter Publish In Minute"
                        value={this.state.newPublishinminute}
                        onChange={(e) =>
                          this.setState({
                            newPublishinminute: e.target.value,
                            publishinminuteValidationError: e.target.value > 0
                              ? ""
                              : "Publish In Minute can't be Zero or less",
                          })
                        }
                        helperText={this.state.publishinminuteValidationError}
                        error={this.state.publishinminuteValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Last Published <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          ampm={true}
                          renderInput={(props) => (
                            <TextField
                              fullWidth
                              {...props}
                              inputProps={{
                                ...props.inputProps,
                                readOnly: true,
                              }}
                              helperText={this.state.lastpublishedValidationError}
                              error={this.state.lastpublishedValidationError.length > 0}
                            />
                          )}
                          label="Last Published"
                          value={this.state.newLastpublished}
                          inputFormat="DD/MM/YYYY hh:mm:ss a"
                          onChange={(e) => {
                            this.setState({
                              newLastpublished: e,
                              lastpublishedValidationError: e
                                ? ""
                                : "Last Published can't be Empty",
                            })
                          }}
                        />
                      </LocalizationProvider>
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        File Name<br />(abc.csv) <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="File Name (required)"
                        placeholder=" Enter File Name as abc.csv"
                        value={this.state.newFilename}
                        onChange={(e) =>
                          this.setState({
                            newFilename: e.target.value,
                            filenameValidationError: e.target.value
                              ? ""
                              : "File Name can't be Empty",
                          })
                        }
                        helperText={this.state.filenameValidationError}
                        error={this.state.filenameValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Status <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <Select
                        isMulti
                        menuPlacement="auto"
                        blurInputOnSelect={false}
                        className="basic-single"
                        classNamePrefix="select"
                        value={this.state.newStatus}
                        name="Status"
                        menuPortalTarget={document.body}
                        styles={Constants.Styles}
                        options={this.state.allStatusOptions}
                        onChange={(selectedOption) => {
                          this.setState({ newStatus: selectedOption })
                          this.handleSelectChange('status', selectedOption)
                        }
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Stone Type <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <Select
                        isMulti
                        menuPlacement="auto"
                        blurInputOnSelect={false}
                        className="basic-single"
                        classNamePrefix="select"
                        value={this.state.newStoneType}
                        name="StoneType"
                        menuPortalTarget={document.body}
                        styles={Constants.Styles}
                        options={this.state.allStoneTypeOptions}
                        onChange={(selectedOption) => {
                          this.setState({ newStoneType: selectedOption })
                          this.handleSelectChange('stonetype', selectedOption)
                        }
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Location <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <Select
                        isMulti
                        menuPlacement="auto"
                        blurInputOnSelect={false}
                        className="basic-single"
                        classNamePrefix="select"
                        value={this.state.newLocation}
                        name="Location"
                        menuPortalTarget={document.body}
                        styles={Constants.Styles}
                        options={this.state.allLocationOptions}
                        onChange={(selectedOption) => {
                          this.setState({ newLocation: selectedOption })
                          this.handleSelectChange('location', selectedOption)
                        }
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>

              <div style={{ textAlign: 'start' }}>
                <Form.Label>
                  Column Name<sup style={{ color: "red" }}>*</sup>
                </Form.Label>
              </div>
              <table display="flex" width="100%">
                <tbody>
                  <td width="50%" maxHeight="60px">
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Search columns"
                      onChange={(e) => this.setState({ srcSearch: e.target.value })}
                      style={{ marginBottom: '10px' }}
                    />
                    <div style={{ overflowY: "auto", width: "100%", maxHeight: "250px", minHeight: "250px", border: "1pt solid black" }}>
                      <table width="100%">
                        <tbody>
                          {this.state.srcAll.filter((item) =>
                            item.toLowerCase().includes(this.state.srcSearch.toLowerCase() || "")
                          ).map((item, index) => {
                            return (
                              <tr>
                                <td
                                  key={index}
                                  onClick={() => this.setSrcSelected(item)}
                                  style={{
                                    backgroundColor:
                                      this.state.srcSelected.includes(item) ?
                                        "grey" :
                                        "white",
                                    color:
                                      this.state.srcSelected.includes(item) ?
                                        "white" :
                                        "black",
                                    paddingLeft: 10,
                                  }}
                                >
                                  {item}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </td>

                  <td style={{ paddingTop: "50px" }}>
                    <tr>
                      <IconButton size="large" sx={{ color: 'black' }} onClick={() => this.handleMoveAllToDst()} >
                        <KeyboardDoubleArrowRightOutlined fontSize="inherit" />
                      </IconButton>
                    </tr>
                    <tr>
                      <IconButton size="large" sx={{ color: 'black' }} onClick={() => this.handleSelectedToDst()}>
                        <KeyboardArrowRightOutlined fontSize="inherit" />
                      </IconButton>
                    </tr>
                    <tr>
                      <IconButton size="large" sx={{ color: 'black' }} onClick={() => this.handleSelectedToSrc()}>
                        <KeyboardArrowLeftOutlined fontSize="inherit" />
                      </IconButton>
                    </tr>
                    <tr>
                      <IconButton size="large" sx={{ color: 'black' }} onClick={() => this.handleMoveAllToSrc()}>
                        <KeyboardDoubleArrowLeftOutlined fontSize="inherit" />
                      </IconButton>
                    </tr>
                  </td>

                  <td display="flex" flex="1px" width="50%">
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Search columns"
                      onChange={(e) => this.setState({ dstSearch: e.target.value })}
                      style={{ marginBottom: '10px' }}
                    />
                    <div style={{ overflowY: "auto", width: "100%", maxHeight: "250px", minHeight: "250px", border: "1pt solid black" }}>
                      <table display="flex" flex="1px" width="100%" >
                        <tbody>
                          <tr>
                            {this.state.dstAll
                              .map((item, index) => ({ item, renamed: this.state.dstRenamed[index], originalIndex: index }))
                              .filter(({ item }) =>
                                item.toLowerCase().includes(this.state.dstSearch.toLowerCase() || "")
                              )
                              .map(({ item, renamed, originalIndex }) => (
                                <tr>
                                  <td
                                    key={originalIndex}
                                    onClick={() => this.setDstSelected(item)}
                                    style={{
                                      backgroundColor:
                                        this.state.dstSelected.includes(item) ?
                                          "grey" :
                                          "white",
                                      color:
                                        this.state.dstSelected.includes(item) ?
                                          "white" :
                                          "black",
                                      paddingLeft: 10,
                                      paddingRight: 10,
                                    }}
                                  >
                                    {item}
                                  </td>
                                  <td>
                                    <TextField
                                      sx={{ margin: "4px 0" }}
                                      fullWidth
                                      size="small"
                                      // label={renamed}
                                      placeholder={`Rename column ${item} to`}
                                      value={renamed}
                                      onChange={(e) => {
                                        let tmpRenamed = [...this.state.dstRenamed];
                                        tmpRenamed[originalIndex] = e.target.value

                                        this.setState({
                                          dstRenamed: tmpRenamed,
                                        });
                                      }}
                                    />
                                  </td>
                                  <td style={{ width: "17%" }}>
                                    <Box sx={{
                                      display: "flex",
                                      justifyContent: "space-evenly",
                                      alignItems: "center",
                                      "& .MuiSvgIcon-root": {
                                        border: "1px solid lightgray",
                                        borderRadius: "4px",
                                        cursor: "pointer"
                                      }
                                    }}>
                                      <KeyboardArrowUpIcon onClick={() => this.shiftColumnUp(originalIndex)} />
                                      <KeyboardArrowDownIcon onClick={() => this.shiftColumnDown(originalIndex)} />
                                    </Box>
                                  </td>
                                </tr>
                              ))}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tbody>
              </table>

              <tr>
                <td>&nbsp;</td>
              </tr>
              <div style={{ textAlign: 'start' }}>
                <Form.Label>
                  Rename
                </Form.Label>
              </div>
              <CustomerFTPRenameColumnWrapper
                renameColumnObj={this.state.renameColumnObj}
                renameColumnData={this.renameColumnData}
              />

              <Box sx={{ display: "flex", mt: 1, justifyContent: "flex-start" }}>
                <Box sx={{ ml: 0 }}></Box>
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.newDisabled}
                        onChange={(e) =>
                          this.setState({
                            newDisabled: !this.state.newDisabled
                          })
                        }
                      />
                    }
                    label="Disabled"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "1rem",
                      },
                    }}
                  />
                </Box>
              </Box>
            </center>

          </Modal.Body>
          <Modal.Footer>
            {/* {Utility.isUpdateAllowed(this.state.local_Permission) ? ( */}
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            {/* ) : null} */}
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box >
    )

  }
}